import { ROUTES_CONSTANTS } from '@shared/configs';
import { CHECK_PROCESS_STATE_ENUMERATION } from './check-process.enumeration';

export const checkProcessRedirect = (
  state: CHECK_PROCESS_STATE_ENUMERATION,
  excludeStates: CHECK_PROCESS_STATE_ENUMERATION[]
): string => {
  if (excludeStates.includes(state)) {
    return;
  }

  const redirect = checkProcessRedirects[state];
  return redirect ? redirect() : ROUTES_CONSTANTS.HOME;
};

const checkProcessRedirects = {
  [CHECK_PROCESS_STATE_ENUMERATION.PENDING_DISPERSION_METHOD]: () => ROUTES_CONSTANTS.DISPERSION_METHOD,
  [CHECK_PROCESS_STATE_ENUMERATION.INVALID_PROCESS]: () => ROUTES_CONSTANTS.HOME,
  [CHECK_PROCESS_STATE_ENUMERATION.PENDING_REFERENCES]: () => ROUTES_CONSTANTS.REFERENCES,
  [CHECK_PROCESS_STATE_ENUMERATION.PENDING_SIGNATURE]: () => ROUTES_CONSTANTS.SIGN_APPLICATION,
};
